export type HsqCommand = [string, ...unknown[]]

declare global {
  interface Window {
    _hsq?: HsqCommand[]
  }
}

export function createInitialHubSpotCommands(path: string): HsqCommand[] {
  return [["setPath", path]]
}

function serializeForInlineScript(value: unknown): string {
  return JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029")
}

export function buildHubSpotBootstrapScript(path: string): string {
  const commands = serializeForInlineScript(createInitialHubSpotCommands(path))
  return `window._hsq = window._hsq || []; window._hsq.push(...${commands});`
}

function enqueue(command: HsqCommand): void {
  if (typeof window === "undefined") {
    return
  }
  window._hsq = window._hsq || []
  window._hsq.push(command)
}

export function hsIdentify(email: string): void {
  if (email) {
    enqueue(["identify", { email }])
  }
}

export function createPageViewCommands(path: string): HsqCommand[] {
  return path ? [["setPath", path], ["trackPageView"]] : []
}

export function hsTrackPageView(path: string): void {
  createPageViewCommands(path).forEach(enqueue)
}
